/* unplugin-vue-components disabled */import script from "./InformationBinding.vue?vue&type=script&lang=ts&setup=true"
export * from "./InformationBinding.vue?vue&type=script&lang=ts&setup=true"

import "./InformationBinding.vue?vue&type=style&index=0&id=d8ade60c&lang=less&scoped=true"

import exportComponent from "/data/liulv-h5/quantum-technology/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8ade60c"]])

export default __exports__